exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n.uk-button.uk-button-danger {\n  font-size: 14px; }\n\n.attraction-form .uk-form-controls {\n  font-size: 14px; }\n  .attraction-form .uk-form-controls input[type=\"checkbox\"] {\n    margin-top: 10px; }\n  .attraction-form .uk-form-controls .uk-button.uk-button-success:disabled {\n    background: #f5f5f5;\n    color: #999;\n    text-shadow: none;\n    border: solid 1px rgba(0, 0, 0, 0.2); }\n  .attraction-form .uk-form-controls.new-cost input {\n    margin-bottom: 4px; }\n  .attraction-form .uk-form-controls .amenities-option, .attraction-form .uk-form-controls .season-option, .attraction-form .uk-form-controls .cuisine-option {\n    margin-top: 4px; }\n\n.attraction-form a.options-btn {\n  font-size: 7px; }\n\n.attraction-form a.uk-close {\n  float: right;\n  cursor: pointer;\n  z-index: 4;\n  margin-bottom: 4px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/attractions/attraction-view/attraction-view.component.scss
// module id = ../../../../../src-admin/app/components/attractions/attraction-view/attraction-view.component.scss
// module chunks = main